import React from "react";
import { createRoot } from "react-dom/client";
import Website from "./Website";
import { DASHBOARD_URL, PORTAL_URL } from "./links";

function redirectLegacyRoute() {
  // Older bookmarks, verification links and checkout returns used the root page.
  const hash = location.hash,
    query = new URLSearchParams(location.search);
  if (hash === "#wall") {
    location.replace(PORTAL_URL + location.search);
    return true;
  }
  if (hash || query.has("invitation") || query.has("checkout")) {
    location.replace(DASHBOARD_URL + location.search + hash);
    return true;
  }
  return false;
}
if (!redirectLegacyRoute()) {
  window.addEventListener("hashchange", redirectLegacyRoute);
  createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <Website />
    </React.StrictMode>,
  );
}
